// extracted by mini-css-extract-plugin
module.exports = {"fixedBottomLayer":"styles_fixedBottomLayer__TazQ0","featuresContainer":"styles_featuresContainer__AYLIQ","section":"styles_section__3AvKq"};